import React from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  Spinner
} from '../../components'

import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'

class SetUserEmail extends React.Component {
  static propTypes = {
    identity: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    renderSet: PropTypes.element,
    className: PropTypes.string,
    data: PropTypes.object.isRequired
  }

  static defaultProps = {
    renderSet: null
  }

  constructor(props) {
    super(props)

    this.state = {
      mutationSuccess: null
    }
  }

  setAsLoginUsername = () => {
    let input = {
      id: this.props.data.identity.user.id,
      email: this.props.email
    }

    this.props.saveUserEmail({ variables: { input }})
    .then(() => {
      console.log("User email update successful")
      this.setState({ mutationSuccess: true })
    })
    .catch((error) => {
      console.log("User email failed to save", error)
      this.setState({ mutationSuccess: false })
    })
  }

  render() {
    let { data, email, renderSet, className } = this.props

    if (data.loading) {
      return <Spinner type="brand" size="x-small" />
    }

    if (data.error) {
      console.error("Error occurred fetching data", data.error)
      return (
        <Button
          disabled={true}>
          Set for login
        </Button>
      )
    }

    if (data.identity.user.email === email) {
      return renderSet
    } else if (this.state.mutationSuccess === false) {
      return (
        <div className={`slds-text-body_small slds-p-left_small ${className ? className : ''}`}>
          Setting login failed. <a onClick={() => this.setState({ mutationSuccess: null })}>Try again</a>
        </div>
      )
    } else if (this.state.mutationSuccess === null){
      return (
        <Button
          onClick={this.setAsLoginUsername}
          className={className ? className : ''}>
          Set for login
        </Button>
      )
    } else {
      if (renderSet) {
        return renderSet
      } else {
        return (
          <div className={`slds-text-body_small slds-p-left_small ${className ? className : ''}`}>
            Setting login username successful.
          </div>
        )
      }
    }
  }
}


const getIdentityUser = gql`
  query($id: ID!) {
    identity(id: $id) {
      id
      user {
        id
        email
      }
    }
  }
`

const saveUserEmail = gql`
  mutation saveUserEmail($input: UserMutationInput!) {
    userMutate(input: $input) {
      user {
        id
        email
      }
    }
  }
`

const withUser =
  graphql(getIdentityUser, {
    options: (ownProps) => ({
      variables: {
        id: ownProps.identity
      }
    })
  })

const withUserMutate =
  graphql(saveUserEmail, {
    name: 'saveUserEmail'
  })

export default compose(
  withUser,
  withUserMutate
)(SetUserEmail)



// WEBPACK FOOTER //
// ./src/components/set-user-email/index.js